import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMapPin2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="map-pin-2, location" maskId="round-filled-radius-0-stroke-1.5-IconMapPin2"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C16.4183 2 20 5.58172 20 10C20 14.7862 15 17.5 13.1084 21.3418C12.8831 21.7444 12.4613 22 12 22C11.5387 22 11.0954 21.7557 10.8916 21.3418C9 17.5 4 14.7862 4 10C4 5.58172 7.58172 2 12 2ZM12 6.5C10.067 6.5 8.5 8.067 8.5 10C8.5 11.933 10.067 13.5 12 13.5C13.933 13.5 15.5 11.933 15.5 10C15.5 8.067 13.933 6.5 12 6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMapPin2;
